import { Link } from "react-router-dom";
import type { Category } from "@/mocks/categories";

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={category.imageUrl}
          alt={category.name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <div className="flex items-center gap-2 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
              <i className={category.icon} />
            </span>
            <span className="text-background-50 font-bold text-lg">
              {category.name}
            </span>
          </div>
          <p className="text-background-50/80 text-sm line-clamp-2">
            {category.description}
          </p>
          <div className="mt-2 text-xs text-background-50/60">
            {category.articleCount} 篇内容
          </div>
        </div>
      </div>
    </Link>
  );
}